// extracted by mini-css-extract-plugin
export var b_checkbox = "styles-module--b_checkbox--GQetT";
export var blink = "styles-module--blink--KtyMz";
export var checkmark = "styles-module--checkmark--KNq09";